module.exports = __webpack_public_path__ + "img/new-barcode-icon-blue.40a5da04.svg";